export const listPrices = `
   query listPrices($filter: PricesFilterInput, $limit: Int, $nextToken: String) {
       listPrices(filter: $filter, limit: $limit, nextToken: $nextToken) {
           items {
              id
              currency
              product
              unitAmount
              active
              nickname
              billingScheme
              recurring {
                interval
                intervalCount
              }
           }
           nextToken
       }
   }
`;

export const getPrice = `
   query getPrice($id:ID!) {
       getPrice(id:$id) {
         id
         currency
         product
         unitAmount
         active
         nickname
         billingScheme
         recurring {
            interval
            intervalCount
         }
       } 
}`;
